module.exports = __webpack_public_path__ + "static/img/Bachelor_010742.fa9de1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010742.jpg
// module id = 240
// module chunks = 0